import { ssoHttp } from "../base"

export async function postRegister(formData) {
  console.log("postRegister:", formData)
  try {
      const response = await ssoHttp.post(
          `v1/users/register`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return response
  } catch (error) {
      console.error("Register error details:", error);
      return error
  }
}
